import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import api from "../../services/baseUrl";
import { useLibrary } from "../../context/LibraryContext";
import { useNavigate } from "react-router-dom";
import download from "downloadjs";
import Modal from "../eGazette/search/Modal";

export default function Bookmark() {
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const user = JSON.parse(cookie).user;

  const [caseLawBookmarks, setCaseLawBookmarks] = useState([]);
  const [lawLibraryBookmarks, setLawLibraryBookmarks] = useState([]);
  const { setLibraryId } = useLibrary();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [caseLawDocumentId, setCaseLawDocumentID] = useState("");
  const [file, setFile] = useState(null);
  const [fileUUID, setFileUUID] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchBookmark = async () => {
      try {
        const response = await api.get("/bookmark/list", {
          params: { username: user.userName },
        });

        const bookmarks = response.data;

        // Split by document type
        const caseLaw = bookmarks.filter((b) => b.documentType === "CaseLaw");
        const lawLibrary = bookmarks.filter(
          (b) => b.documentType === "LawLibrary"
        );

        setCaseLawBookmarks(caseLaw);
        setLawLibraryBookmarks(lawLibrary);
      } catch (error) {
        console.error(
          "Error fetching bookmarks:",
          error.response?.data || error.message
        );
      }
    };

    fetchBookmark();
  }, [user.userName]);

  const openModal = async (uuid) => {
    if (uuid) {
      setFileUUID(uuid);
      fetchPdf(uuid);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFile(null);
    setCaseLawDocumentID("");
    fetchBookmark();
  };

  const fetchBookmark = async () => {
    try {
      const response = await api.get("/bookmark/list", {
        params: { username: user.userName },
      });

      const bookmarks = response.data;

      // Split by document type
      const caseLaw = bookmarks.filter((b) => b.documentType === "CaseLaw");
      const lawLibrary = bookmarks.filter(
        (b) => b.documentType === "LawLibrary"
      );

      setCaseLawBookmarks(caseLaw);
      setLawLibraryBookmarks(lawLibrary);
    } catch (error) {
      console.error(
        "Error fetching bookmarks:",
        error.response?.data || error.message
      );
    }
  };

  const navigateLawLibraryDocument = async (document) => {
    const responseLibraryId = await api.get(
      "/api/lawlibrary-documents/getLibraryId",
      {
        params: { documentId: document.documentId },
      }
    );

    if (responseLibraryId.status === 200) {
      setLibraryId(responseLibraryId.data);
      if (document.subDocumentId === 0) {
        navigate(`/law-library/document?documentID=${document.documentId}`);
      } else {
        navigate(
          `/law-library/document?subdocumentId=${document.subDocumentId}`
        );
      }
    }
  };

  const fetchCaseLawPdf = async (documentID) => {
    setCaseLawDocumentID(documentID);
    try {
      const response = await api.get("/api/caselaw-documents/fileUUID", {
        params: { documentID: documentID },
        headers: {
          "Content-Type": "application/json",
        },
      });

      setFileUUID(response.data);
      openModal(response.data);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const fetchPdf = async (uuid) => {
    try {
      const response = await api.post(
        "/document/pdf",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const downloadPdf = async (uuid) => {
    try {
      const fileNameEndpoint = "/api/caselaw-documents/getFileName";
      const fileNameResponse = await api.post(
        fileNameEndpoint,
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const fileNameText = await fileNameResponse.data;
      const fileName = fileNameText.split("/").pop();

      const response = await api.post(
        "/document/pdf/download",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      download(response.data, fileName, contentType);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  return (
    <div style={{ padding: "25px", display: "flex", gap: "20px" }}>
      {/* CaseLaw Table */}
      <div className="safety-one-table">
        <p className="safety-blue-row">Case Law</p>
        {caseLawBookmarks.map((doc, index) => (
          <p
            key={doc.id || index}
            className={index % 2 === 0 ? "safety-white-row" : "safety-grey-row"}
            onClick={() => {
              fetchCaseLawPdf(doc.documentId);
            }}
            style={{ cursor: "pointer" }}
          >
            {doc.caseLawDocumentTitle}
          </p>
        ))}
      </div>

      {/* LawLibrary Table */}
      <div className="safety-one-table">
        <p className="safety-blue-row">Law Library</p>
        {lawLibraryBookmarks.map((doc, index) => (
          <p
            key={doc.id || index}
            className={index % 2 === 0 ? "safety-white-row" : "safety-grey-row"}
            onClick={() => {
              navigateLawLibraryDocument(doc);
            }}
            style={{ cursor: "pointer" }}
          >
            {doc.lawLibraryDocumentTitle}
            {doc.lawLibrarySubdocumentTitle.trim() !== "" &&
              ` - ${doc.lawLibrarySubdocumentTitle}`}
          </p>
        ))}
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        pdf={file}
        pageNumber={1}
        fileUUID={fileUUID}
        downloadPdf={(uuid) => downloadPdf(uuid)}
        documentId={caseLawDocumentId}
      />
    </div>
  );
}
